// app/javascript/controllers/documents_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["customerSelect", "relevanceSelect", "contentcategorySelect"]

  connect() {
    console.log("DocumentsController connected")
  }

  customerChanged(event) {
    const customerId = this.customerSelectTarget.value
    if (!customerId) return

    fetch(`/customers/${customerId}/related_data`)
      .then(response => response.json())
      .then(data => {
        console.log("Daten vom Server:", data)
        this.allCategories = data.contentcategories || []
        this.updateContentcategories()
      })
      .catch(error => {
        console.error("Fehler beim Laden der Daten:", error)
      })
  }

  relevanceChanged(event) {
    this.updateContentcategories()
  }

  updateContentcategories() {
    const relevance = this.relevanceSelectTarget.value

    const filtered = this.allCategories.filter(c => !relevance || c.relevance === relevance)

    this.fillSelect(this.contentcategorySelectTarget, filtered)
  }

  fillSelect(select, options, selectedId = "") {
    select.innerHTML = ""

    // Prompt-Option
    const promptOption = document.createElement("option")
    promptOption.value = ""
    promptOption.textContent = "Bitte wählen"
    select.appendChild(promptOption)

    options.forEach(opt => {
      const option = document.createElement("option")
      option.value = opt.id
      option.textContent = opt.name_de
      if (selectedId && selectedId.toString() === opt.id.toString()) {
        option.selected = true
      }
      select.appendChild(option)
    })
  }
}